<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信RM设置设备ID（终端ID）'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="sms" label="设备ID（终端ID）">
        <Input v-model="terminationID" placeholder="设备ID（终端ID）" style="width: 220px;" @on-change="onChange">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuprmnumbersmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        terminationID:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        if (!this.terminationID || this.terminationID === '') {
          this.$Message.error('请填写设备ID（终端ID）')
          return
        }
        //共三条短信，对应不同密码
        // console.log(this.simNum.substring(6))

          this.sendSMS('99admin,admin,SDID'+this.terminationID+'! ')

          setTimeout(() => {
              this.sendSMS('99admin,JC336699,SDID'+this.terminationID+'! ')
            }
            ,100)

          setTimeout(() => {
              this.sendSMS('99admin,,SDID'+this.terminationID+'! ')
            }
            ,2000)

        setTimeout(() => {
            this.sendSMS('99admin,JcBOZSJCB0,SDID'+this.terminationID+'! ')
          }
          ,3000)
      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
          this.terminationID = this.simNum.substring(6)
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
